import React from "react";
import {
  CityField,
  EmailField,
  FirstNameField,
  LastNameField,
  PasswordField,
  PhoneField,
} from "./SettingsPersonalInfoTextfields";
import { Col, Row } from "react-bootstrap";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";
import { ProfileDetails } from "../../../../model/settings/SettingsPersonalInfoModel";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import ImagePickerPreview from "../../../../widget/common/form/ImagePickerPreview";
import { SettingsPersonalProfileContextImport } from "../../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";

const SettingsPersonalInfoForm = (props: {
  profile?: ProfileDetails;
  type?: number | undefined;
}) => {
  const profileInfo = props.profile ?? null;
  const type: number = props.type ?? ResponsiveDeviceType();
  const logoSize = type === 1 ? 149 : type === 2 ? 180 : 200;

  const { updateFileString } = SettingsPersonalProfileContextImport();

  const getPreview = (preview: string | null, fileDetail: File | null) => {
    updateFileString(preview, fileDetail);
  };

  return (
    <>
      {profileInfo != null && (
        <>
          <Div>
            <Center>
              <ImagePickerPreview getPreview={getPreview} size={logoSize}>
                <LogoRound
                  url={profileInfo?.logo_details?.file_url!}
                  isProfile={true}
                  name={`${profileInfo.first_name!} ${profileInfo.last_name!}`}
                  size={logoSize}
                />
              </ImagePickerPreview>
            </Center>
          </Div>
          <SpacingHeight value={type === 3 ? 50 : 40} />
          <form autoComplete="off">
            <Row>
              <Col xs={12} lg={6}>
                <FirstNameField />
              </Col>
              <Col xs={12} lg={6}>
                <LastNameField />
              </Col>
              <Col xs={12} lg={6}>
                <EmailField />
              </Col>
              <Col xs={12} lg={6}>
                <PhoneField />
              </Col>
              <Col xs={12} lg={6}>
                <PasswordField />
              </Col>
              <Col xs={12} lg={6}>
                <CityField />
              </Col>
            </Row>
          </form>
        </>
      )}
    </>
  );
};

export default SettingsPersonalInfoForm;
